export const OUTLOOK_CONFIG_CONSTANT = {
    LOAD_OUTLOOK_WORKREQUEST_CONFIG: 'LOAD_OUTLOOK_WORKREQUEST_CONFIG',
    UPDATE_WORKREQUEST_DATA: 'UPDATE_WORKREQUEST_DATA'
};